import React, { useState } from "react";
import "./Settings.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  AccessTockenReducer,
  loginReducer,
  sidebarReducer,
} from "../../Redux/store";
import axios from "axios";
import {
  SuccessUpdate,
  FailureUpdate,
} from "../../components/Alert_msg/alert_msg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
};

function Settings() {
  // Dispatch function
  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  const user_id = useSelector((state) => state.Login.loginUser_id);
  const sessionLimit = useSelector(
    (state) => state.AccessTocken.recordsPerPage
  );

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  var passwordValid = new RegExp(
    /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#/$%^&*])(?=.{8,20})/
  );

  const [listLimit, setListLimit] = useState(Number(sessionLimit));
  const [cpStatus, setCpStatus] = useState(false);

  const [oldP, setOldP] = useState("");
  const [newP, setNewP] = useState("");
  const [reNewP, setReNewP] = useState("");

  const buttonSX = { backgroundColor: "var(--themes-color)", color: "white" };

  const limitChange = (event) => {
    setListLimit(event.target.value);
  };

  const onSave = () => {
    axios
      .put(
        `settings/update`,
        {
          settingsVar: "limit",
          settingsValue: listLimit,
          // userid: user_id,
        },
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.update_success(true));
          dispatch(AccessTockenReducer.recordsPerPage(listLimit));
        } else {
          dispatch(sidebarReducer.update_failure(true));
        }
      })
      .catch((err) => {
        if (err) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
          dispatch(sidebarReducer.update_failure(true));
        }
      });
  };

  const cpPopupChange = () => {
    setCpStatus(!cpStatus);
    setOldP("");
    setNewP("");
    setReNewP("");
  };

  const resetPassword = () => {
    if (oldP.length > 0 && newP.length > 0) {
      if (newP !== oldP) {
        if (newP === reNewP) {
          if (passwordValid.test(newP)) {
            axios
              .put(
                `auth/resetpassword/${user_id}`,
                {
                  oldpassword: oldP,
                  password: newP,
                },
                options
              )
              .then((response) => {
                if (response.status === 200) {
                  dispatch(loginReducer.Logout());
                  dispatch(AccessTockenReducer.accessTocken(""));
                  dispatch(AccessTockenReducer.refreshTocken(""));
                  cpPopupChange();
                  sessionStorage.clear();
                } else {
                  dispatch(sidebarReducer.password_failure(true));
                }
              })
              .catch((err) => {
                if (err) {
                  dispatch(sidebarReducer.stringUpdate("AppDown"));
                }
              });
          } else {
            alert(
              "The Password should have atleast 1 letter, 1 number and 1 special character!"
            );
            return false;
          }
        } else {
          alert("New password and confirm password are not same.");
          return false;
        }
      } else {
        alert("New password should be different than old password.");
        return false;
      }
    } else {
      alert("Please fill all the fields.");
      return false;
    }
  };

  return (
    <div className="m-4" style={{ height: "94vh" }}>
      <div className="row p-0 border rounded-top settingsRow">
        <div className="col-6 d-flex align-items-center">
          <strong>No. of records per page</strong>
        </div>
        <div className="col-6 d-flex align-items-center">
          <FormControl sx={{ width: "100px" }}>
            <InputLabel id="demo-simple-select-label" size="small">
              Limit
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              size="small"
              value={listLimit}
              label="Records"
              onChange={limitChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={30}>30</MenuItem>
              <MenuItem value={35}>35</MenuItem>
              <MenuItem value={40}>40</MenuItem>
              <MenuItem value={45}>45</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="row my-2 settingsRow">
        <div className="col">
          <button
            type="button"
            className="btn me-2"
            style={buttonSX}
            onClick={cpPopupChange}
          >
            Change password
          </button>
          <button
            type="button"
            className="btn mx-2"
            style={buttonSX}
            onClick={onSave}
          >
            Save
          </button>
        </div>
      </div>
      <Modal
        open={cpStatus}
        onClose={cpPopupChange}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="border m-3 py-3 rounded d-flex justify-content-center">
            <div>
              <div className="my-2">
                <TextField
                  id="outlined-basic"
                  label="Current Password"
                  variant="outlined"
                  size="small"
                  type="password"
                  onChange={(e) => {
                    setOldP(e.target.value);
                  }}
                />
              </div>
              <div className="my-2">
                <TextField
                  id="outlined-basic"
                  label="New Password"
                  variant="outlined"
                  size="small"
                  type="password"
                  onChange={(e) => {
                    setNewP(e.target.value);
                  }}
                />
              </div>
              <div className="my-2">
                <TextField
                  id="outlined-basic"
                  label="Confirm Password"
                  variant="outlined"
                  size="small"
                  type="password"
                  onChange={(e) => {
                    setReNewP(e.target.value);
                  }}
                />
              </div>
              <div className="d-flex justify-content-between align-items-baseline ms-2 mb-2">
                <button
                  type="button"
                  className="btn me-2"
                  style={buttonSX}
                  onClick={resetPassword}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger mx-2"
                  onClick={cpPopupChange}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <SuccessUpdate />
      <FailureUpdate />
    </div>
  );
}

export default Settings;
